"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackgroundCheckScreeningKind = void 0;
exports.instanceOfBackgroundCheckScreeningKind = instanceOfBackgroundCheckScreeningKind;
exports.BackgroundCheckScreeningKindFromJSON = BackgroundCheckScreeningKindFromJSON;
exports.BackgroundCheckScreeningKindFromJSONTyped = BackgroundCheckScreeningKindFromJSONTyped;
exports.BackgroundCheckScreeningKindToJSON = BackgroundCheckScreeningKindToJSON;
exports.BackgroundCheckScreeningKindToJSONTyped = BackgroundCheckScreeningKindToJSONTyped;
/**
 *
 * @export
 */
exports.BackgroundCheckScreeningKind = {
    BackgroundCheck: 'BACKGROUND_CHECK',
    DrugScreen: 'DRUG_SCREEN',
    TbTest: 'TB_TEST',
    Other: 'OTHER'
};
function instanceOfBackgroundCheckScreeningKind(value) {
    for (const key in exports.BackgroundCheckScreeningKind) {
        if (Object.prototype.hasOwnProperty.call(exports.BackgroundCheckScreeningKind, key)) {
            if (exports.BackgroundCheckScreeningKind[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function BackgroundCheckScreeningKindFromJSON(json) {
    return BackgroundCheckScreeningKindFromJSONTyped(json, false);
}
function BackgroundCheckScreeningKindFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function BackgroundCheckScreeningKindToJSON(value) {
    return value;
}
function BackgroundCheckScreeningKindToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=BackgroundCheckScreeningKind.js.map